import { useCallback, useEffect } from 'react';

import log from 'loglevel';

import { useFetchCacheStore } from '../../store';
import { useTeamsCommunicationsStore } from '../../store/Inbox/TeamsCommunications';
import { useFetchTeamsChats } from '../UserCommunications/fetch/useFetchTeamsChats';

export const useTeamsDataFetch = () => {
  const { markTeamsChatsAsLoaded, isTeamsChatsLoaded } = useFetchCacheStore();
  const { saveTeamsChats } = useTeamsCommunicationsStore();
  const { handleFetchTeamsChats } = useFetchTeamsChats();

  const onTeamsDataFetch = useCallback(async () => {
    if (isTeamsChatsLoaded()) {
      log.info('Teams chats already loaded, skipping fetch');
      return;
    }

    try {
      await handleFetchTeamsChats();
      markTeamsChatsAsLoaded();
    } catch (error) {
      log.error('Error fetching Teams chats:', error);
    }
  }, [isTeamsChatsLoaded, markTeamsChatsAsLoaded, saveTeamsChats]);

  useEffect(() => {
    onTeamsDataFetch();
  }, []);
};
